import { TableRow, TableCell, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ApiManager from "../../ApiManager";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const TaskRow = (props) => {
    const {
        row,
        columns,
        reload
    } = props;

    const typeTask = [
        "Не назначено",
        "Удаление",
        "Сломана"
    ];
    const viewTypeTask = [
        "Везде",
        "БД",
        "ОЗУ"
    ];

    const submitDelete = (upid) => {
        confirmAlert({
            title: 'Подтвердить удаление',
            message: 'Точно удалить задачу: ' + upid + '?',
            buttons: [
                {
                    label: 'Да',
                    onClick: () => deleteAction(upid)
                },
                {
                    label: 'Нет',
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
        });
    };

    const deleteAction = async (upid) => {
        try {
            await ApiManager.taskDelete(upid);
            reload();
        } catch (e) {
            //console.log(e.message)
        }
    };

    return (
        <TableRow key={"taskDataId_" + row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            {columns.map((column) => {
                let dataRow;

                switch (column.id) {
                    case "timeStampStart":
                        dataRow = new Date(row[column.id] * 1000).toLocaleString();
                        break;
                    case "typeTask":
                        dataRow = typeTask[row[column.id]];
                        break;
                    case "viewTypeTask":
                        dataRow = viewTypeTask[row[column.id]];
                        break;
                    case "status":
                        let isComplete = row["isComplete"];
                        let isError = row["isError"];

                        if (isComplete === null || isComplete === undefined || isError === null || isError === undefined) {
                            break;
                        }

                        if (isComplete && isError) {
                            dataRow = "Сломано";
                            break;
                        }

                        if (isComplete) {
                            dataRow = "Успешно";
                        }

                        if (isError) {
                            dataRow = "Ошибка";
                        }

                        dataRow = "Ожидание";
                        break;
                    case "action":
                        dataRow = <IconButton key={row.upid} onClick={() => submitDelete(row.upid)}
                            sx={{
                                width: '50px',
                                height: '50px',
                                "& .MuiTouchRipple-root": {
                                    color: "#2a73de",
                                }
                            }}
                            title="delete"
                        >
                            <DeleteIcon sx={{
                                "& path": {
                                    color: "#2a73de"
                                }
                            }} />
                        </IconButton>;
                        break;
                    default:
                        if (row[column.id] === null || row[column.id] === undefined) {
                            dataRow = "";
                        }
                        else {
                            dataRow = row[column.id];
                        }
                }

                return <TableCell key={"cell_" + column.id + "_" + row.id} align="left">
                    {dataRow}
                </TableCell>
            })}
        </TableRow>
    );
}

export default TaskRow